module.exports = __webpack_public_path__ + "img/3.585166dd.jpg";